import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function About() {
  return (
    <div className="min-h-screen pt-20 px-4">
      {/* Hero Section */}
      <section className="py-20 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-bold text-5xl md:text-7xl mb-6 bg-gradient-to-r from-primary via-cyan-400 to-primary bg-clip-text text-transparent">
            About ROBOFEST 2025
          </h1>
          <p className="text-xl md:text-2xl text-muted-foreground mb-8">
            Battle of Smart Racers
          </p>
          <p className="text-lg text-cyan-300 max-w-3xl mx-auto leading-relaxed">
            Discover the organizations and institutions behind one of the most exciting robotics competitions in the region
          </p>
        </div>
      </section>

      {/* Organizer Section */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-bold text-4xl md:text-5xl mb-6 text-primary">
              Organizer
            </h2>
          </div>
          
          <Card className="bg-card/50 border-primary/30 card-hover mb-8">
            <CardHeader className="text-center">
              <div className="mb-6">
                <img 
                  src="/assets/srm.png"
                  alt="SRM Institute Logo"
                  className="h-24 md:h-32 mx-auto mb-8"
                />
              </div>
              <CardTitle className="text-3xl text-primary">
                SRM Institute of Science & Technology
              </CardTitle>
            </CardHeader>
            <CardContent className="text-center">
              <p className="text-lg text-muted-foreground leading-relaxed">
                SRM Institute of Science and Technology is one of India's leading private technical universities, 
                consistently ranked among the top institutions for engineering and technology education. With a 
                commitment to excellence in research and innovation, SRM provides the perfect platform for 
                showcasing cutting-edge robotics competitions like ROBOFEST.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Club Section */}
      <section className="py-20 bg-gradient-to-r from-card to-background">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-bold text-4xl md:text-5xl mb-6 text-primary">
              Host Club
            </h2>
          </div>
          
          <Card className="bg-card/50 border-primary/30 card-hover mb-8">
            <CardHeader className="text-center">
              <div className="mb-6">
                <img 
                  src="https://isdlabsrm.in/logo.svg" 
                  alt="ISD Lab Logo" 
                  className="h-14 mx-auto"
                />
              </div>
              <CardTitle className="text-3xl text-primary">
                Intelligent Systems Design Lab (ISD Lab)
              </CardTitle>
            </CardHeader>
            <CardContent className="text-center">
              <p className="text-lg text-muted-foreground leading-relaxed mb-6">
                The Intelligent Systems Design Lab at SRM Institute is dedicated to advancing research and 
                education in robotics, artificial intelligence, and intelligent systems. Our lab serves as 
                the hub for innovative robotics projects and competitions, fostering creativity and technical 
                excellence among students.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
                <div className="flex flex-col items-center space-y-2">
                  <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center">
                    <span className="text-primary font-bold">R&D</span>
                  </div>
                  <span className="text-muted-foreground">Research & Development</span>
                </div>
                <div className="flex flex-col items-center space-y-2">
                  <div className="w-12 h-12 bg-cyan-400/20 rounded-full flex items-center justify-center">
                    <span className="text-cyan-400 font-bold">AI</span>
                  </div>
                  <span className="text-muted-foreground">Artificial Intelligence</span>
                </div>
                <div className="flex flex-col items-center space-y-2">
                  <div className="w-12 h-12 bg-green-400/20 rounded-full flex items-center justify-center">
                    <span className="text-green-400 font-bold">🤖</span>
                  </div>
                  <span className="text-muted-foreground">Robotics Innovation</span>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Sponsor Section */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-bold text-4xl md:text-5xl mb-6 text-primary">
              Official Sponsor
            </h2>
          </div>
          
          <Card className="bg-card/50 border-primary/30 card-hover mb-8">
            <CardHeader className="text-center">
              <div className="mb-6">
                <div className="w-20 h-20 bg-gradient-to-r from-green-400 to-blue-500 rounded-full flex items-center justify-center mx-auto">
                  <span className="text-white font-bold text-lg">GUVI</span>
                </div>
              </div>
              <CardTitle className="text-3xl text-primary">
                GUVI – Tech Deserves You
              </CardTitle>
            </CardHeader>
            <CardContent className="text-center">
              <p className="text-lg text-muted-foreground leading-relaxed mb-6">
                GUVI is India's premier tech education platform, empowering millions of learners with cutting-edge 
                programming and technology skills. As our official sponsor, GUVI shares our vision of nurturing 
                the next generation of tech innovators and robotics engineers.
              </p>
              <div className="flex flex-wrap justify-center gap-4 text-sm">
                <span className="bg-primary/20 text-primary px-3 py-1 rounded-full">Programming Education</span>
                <span className="bg-cyan-400/20 text-cyan-400 px-3 py-1 rounded-full">Skill Development</span>
                <span className="bg-green-400/20 text-green-400 px-3 py-1 rounded-full">Career Growth</span>
                <span className="bg-purple-400/20 text-purple-400 px-3 py-1 rounded-full">Tech Innovation</span>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gradient-to-r from-background to-card">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-bold text-4xl md:text-5xl mb-6 text-primary">
              Our Mission & Vision
            </h2>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <Card className="bg-card/50 border-primary/30 card-hover">
              <CardHeader>
                <CardTitle className="text-2xl text-primary flex items-center space-x-3">
                  <div className="w-8 h-8 bg-primary/20 rounded-full flex items-center justify-center">
                    <span className="text-primary">🎯</span>
                  </div>
                  <span>Mission</span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground leading-relaxed">
                  To foster creativity, innovation, and collaboration among the next generation of robotics 
                  engineers through competitive excellence and hands-on learning experiences. We aim to bridge 
                  the gap between theoretical knowledge and practical application in the field of robotics.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-card/50 border-primary/30 card-hover">
              <CardHeader>
                <CardTitle className="text-2xl text-primary flex items-center space-x-3">
                  <div className="w-8 h-8 bg-cyan-400/20 rounded-full flex items-center justify-center">
                    <span className="text-cyan-400">🚀</span>
                  </div>
                  <span>Vision</span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground leading-relaxed">
                  To become the premier robotics competition platform in Southeast Asia, inspiring thousands 
                  of students to pursue careers in robotics, artificial intelligence, and automation technologies. 
                  We envision a future where ROBOFEST graduates lead the robotics revolution globally.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-bold text-4xl md:text-5xl mb-6 text-primary">
              Our Values
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Card className="bg-card/50 border-primary/30 card-hover text-center">
              <CardContent className="pt-6">
                <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🔬</span>
                </div>
                <h3 className="font-bold text-lg text-primary mb-2">Innovation</h3>
                <p className="text-sm text-muted-foreground">
                  Encouraging creative solutions and cutting-edge approaches to robotics challenges
                </p>
              </CardContent>
            </Card>

            <Card className="bg-card/50 border-primary/30 card-hover text-center">
              <CardContent className="pt-6">
                <div className="w-16 h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🤝</span>
                </div>
                <h3 className="font-bold text-lg text-cyan-400 mb-2">Collaboration</h3>
                <p className="text-sm text-muted-foreground">
                  Building strong teams and fostering knowledge sharing among participants
                </p>
              </CardContent>
            </Card>

            <Card className="bg-card/50 border-primary/30 card-hover text-center">
              <CardContent className="pt-6">
                <div className="w-16 h-16 bg-green-400/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🏆</span>
                </div>
                <h3 className="font-bold text-lg text-green-400 mb-2">Excellence</h3>
                <p className="text-sm text-muted-foreground">
                  Striving for the highest standards in technical competency and competition organization
                </p>
              </CardContent>
            </Card>

            <Card className="bg-card/50 border-primary/30 card-hover text-center">
              <CardContent className="pt-6">
                <div className="w-16 h-16 bg-purple-400/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🌍</span>
                </div>
                <h3 className="font-bold text-lg text-purple-400 mb-2">Impact</h3>
                <p className="text-sm text-muted-foreground">
                  Creating meaningful change in the robotics community and beyond
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
}